var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "corssTable" }, [
    _c(
      "table",
      {
        attrs: {
          border: "1",
          cellspacing: "0",
          cellpadding: "0",
          width: _vm.tableConfig.width.table_width,
        },
      },
      _vm._l(_vm.tableConfig.columns, function (th_data, index) {
        return _c(
          "tr",
          { key: index },
          [
            _c("th", { attrs: { width: _vm.tableConfig.width.head_width } }, [
              _vm._v(_vm._s(th_data.title)),
            ]),
            _vm._v(" "),
            _vm._l(_vm.tableConfig.data, function (td_data, index) {
              return _c("td", { key: index, style: _vm.td_style(td_data) }, [
                _vm._v(_vm._s(td_data[th_data.key])),
              ])
            }),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }